import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import DashboardLayout from "@/components/DashboardLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Members from "@/pages/Members";
import Enrollments from "@/pages/Enrollments";
import Orders from "@/pages/Orders";
import Pins from "@/pages/Pins";
import Sheets from "@/pages/Sheets";
import ExportPage from "@/pages/Export";
import Chats from "@/pages/Chats";
import Reports from "@/pages/Reports";
import AdminAllowlist from "@/pages/AdminAllowlist";
import PrescriptionAI from "@/pages/PrescriptionAI";
import Analytics from "@/pages/Analytics";
import OrderDetail from "@/pages/OrderDetail";
import Billing from "@/pages/Billing";
import TdsReport from "@/pages/TdsReport";
import Complaints from "@/pages/Complaints";
import InsuredBK from "@/pages/InsuredBK";
import Integrations from "@/pages/Integrations";
import { Toaster } from "@/components/ui/sonner";

function AppRouter() {
  const location = useLocation();
  // Synchronous check: session_id in URL fragment -> AuthCallback
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/members" element={<Members />} />
        <Route path="/enrollments" element={<Enrollments />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/orders/:id" element={<OrderDetail />} />
        <Route path="/pins" element={<Pins />} />
        <Route path="/sheets" element={<Sheets />} />
        <Route path="/export" element={<ExportPage />} />
        <Route path="/chats" element={<Chats />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/prescription-ai" element={<PrescriptionAI />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/purchase-bills" element={<Billing />} />
        <Route path="/tds-report" element={<Navigate to="/analytics" replace />} />
        <Route path="/complaints" element={<Complaints />} />
        <Route path="/verification/insured-bk" element={<InsuredBK />} />
        <Route path="/integrations" element={<Integrations />} />
        <Route path="/admin/allowlist" element={<AdminAllowlist />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
